import React, { FC } from "react";
import NcImage from "shared/NcImage/NcImage";
import Badge from "shared/Badge/Badge";

const rightImgPng = "https://res.cloudinary.com/dqwlxo5fe/image/upload/v1671103206/nilebooking/our-features_pypb75.png";
export interface SectionOurFeaturesProps {
  className?: string;
  rightImg?: string;
  type?: "type1" | "type2";
}

const SectionOurFeatures: FC<SectionOurFeaturesProps> = ({
  className = "lg:py-14",
  rightImg = rightImgPng,
  type = "type1",
}) => {
  return (
    <div
      className={`nc-SectionOurFeatures relative flex flex-col items-center ${
        type === "type1" ? "lg:flex-row" : "lg:flex-row-reverse"
      } ${className}`}
      data-nc-id="SectionOurFeatures"
    >
      <div className="flex-grow">
        <NcImage src={rightImg} />
      </div>
      <div
        className={`max-w-2xl flex-shrink-0 mt-10 lg:mt-0 lg:w-2/5 ${
          type === "type1" ? "lg:pl-16" : "lg:pr-16"
        }`}
      >
        <span className="uppercase text-sm text-gray-400 tracking-widest">
          Benefits
        </span>
        <h2 className="font-semibold text-4xl mt-5">Why you need Nilebooking </h2>

        <ul className="space-y-10 mt-16">
          <li className="space-y-4">
            <Badge name="Best price" />
            <span className="block text-xl font-semibold">
              Cost-effective 
            </span>
            <span className="block mt-5 text-neutral-500 dark:text-neutral-400">
              Browse 100s of listing on Nilebooking and choose your best price.
            </span>
          </li>
          <li className="space-y-4">
            <Badge color="green" name="Exposure " />
            <span className="block text-xl font-semibold">
              Book hotels and reservations from any where.
            </span>
            <span className="block mt-5 text-neutral-500 dark:text-neutral-400">
              1000s of hotel rooms, apartments and homes to book, reserve from.
            </span>
          </li>
          <li className="space-y-4">
            <Badge color="red" name="Secure" />
            <span className="block text-xl font-semibold">
              Secure and simple
            </span>
            <span className="block mt-5 text-neutral-500 dark:text-neutral-400">
              At Nilebooking we ensure the safety of both our guests and host, all listings
              are cross checked to avoid pontential scams.
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SectionOurFeatures;
